import * as Sentry from '@sentry/react'
import { SENTRY_SEVERITY } from 'src/service/utils/sentry'
import { cmdTypeLabel } from 'src/service/utils/sentry/api'

type FlowPhase = 'request' | 'response'

type FlowBreadcrumbData = {
  cmdType?: string
  errCode?: string
  errMsg?: string
}

export function addApiBreadcrumb(phase: FlowPhase, data: FlowBreadcrumbData) {
  const cmdType = Number(data.cmdType)
  const label = cmdTypeLabel(cmdType)

  Sentry.addBreadcrumb({
    category: 'flow',
    message: `${label}[${phase}]`,
    level: SENTRY_SEVERITY.Info,
    data: {
      ...data,
      cmdType: `${label} (${cmdType})`,
      path: window.location.pathname,
      phase,
    },
  })
}
